import { render, staticRenderFns } from "./ConcernIndustryEmpty.vue?vue&type=template&id=62c34135&scoped=true"
import script from "./ConcernIndustryEmpty.vue?vue&type=script&lang=js"
export * from "./ConcernIndustryEmpty.vue?vue&type=script&lang=js"
import style0 from "./ConcernIndustryEmpty.vue?vue&type=style&index=0&id=62c34135&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c34135",
  null
  
)

export default component.exports